import React from 'react';
import { Drawer as AntDrawer } from 'antd';

/**
 * Wrapper component for Ant Design Drawer
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Drawer functionality including placement, size, and mask options.
 * 
 * @component
 * @example
 * import { Drawer } from '../GeneralComponents/ui';
 * 
 * <Drawer
 *   title="Basic Drawer"
 *   placement="right"
 *   visible={visible}
 *   onClose={onClose}
 * >
 *   <p>Some contents...</p>
 * </Drawer>
 * 
 * @see https://ant.design/components/drawer/ - Ant Design Drawer documentation
 */
const Drawer = (props) => {
  return <AntDrawer {...props} />;
};

export default Drawer;

